module.exports = __webpack_public_path__ + "static/EWY_Kirsty Wilcock_CASE_STUDY-53f46692ed006b06d23feec6fb6cced2.mp4";